import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { Structures } from '@clavisco/core';
import ICLResponse = Structures.Interfaces.ICLResponse;
import { IPermission } from '../interfaces/i-permission';

@Injectable({
  providedIn: 'root'
})
export class PermissionService {

  constructor(
    private http: HttpClient
  ) { }

  /**
 * Retrieves the permissions assigned to a role based on the provided role ID.
 * 
 * @param roleId - The ID of the role for which to fetch permissions.
 * @returns An observable containing the response with the list of permissions for the role.
 */
  GetPermissionsByRol(roleId: number): Observable<ICLResponse<IPermission[]>> {
    return this.http.get<ICLResponse<IPermission[]>>(`api/Permissions/GetPermissionsByRol?roleId=${roleId}`);
  }

}
